<template>
    <div>
        <div class="search-box">
            <p>开始月份：</p>
            <a-month-picker
                :disabled="type=='look'"
                class="input-box"
                valueFormat="YYYY-MM"
                v-model="searchFrom.startDate"
                @change="month"
                >
            </a-month-picker>
            <p>结束月份：</p>
            <a-month-picker
                :disabled="type=='look'"
                class="input-box"
                valueFormat="YYYY-MM"
                v-model="searchFrom.endDate"
                >
            </a-month-picker>
            <p>部门：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.orgCode" >
                <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>职称：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.technicalTitleCode" >
                <a-select-option v-for="(item,index) in zcArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>教师姓名/编号：</p>
            <a-input class="input-box" v-model="searchFrom.teacherIdOrName" />
            <p v-if="sysRoles.indexOf('ROLE_ORG_ADMIN') < 0">状态：</p>
            <a-select class="input-box-short" allowClear v-model="searchFrom.approveStatus" v-if="sysRoles.indexOf('ROLE_ORG_ADMIN') < 0">                        
                <a-select-option  value='draft' >待确认</a-select-option>
                <a-select-option  value='approved' >已确认</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div>
        <div class="operation-box">
            <a-button 
                type="primary"
                icon="plus" 
                class="btn" 
                @click="$router.push('/admin/faculty/payroll/info?type=add')"
                v-if="permissions.indexOf('faculty:payroll:add')>-1"
                >
                 新增
            </a-button>
            <a-button
                v-if="permissions.indexOf('faculty:payroll:edit')>-1"
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() :edit('edit')"
                >
                 调整
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="del()">
                <a-button
                    v-if="permissions.indexOf('faculty:payroll:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    批量删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="check" 
                class="btn" 
                v-if="permissions.indexOf('faculty:payroll:approve')>-1"
                @click="approved()"
                >
                 批量确认
            </a-button>
            <a-button 
                type="primary"
                icon="export" 
                class="btn" 
                @click="exportFile()"
                v-if="permissions.indexOf('faculty:payroll:export')>-1">
                 导出
            </a-button>
        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ y: '600px' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del,exportFile,approved } from '@/baseAPI/payroll'
    import { getSchoolYear,selectedCheck,getSemester } from '@/baseAPI/util'
    
    const columns = [
                        {
                            title: '序号',
                            align:'center',
                            width:70,
                            customRender: (text, row, index) => {
                                return { children: index+1+''};
                            },
                        },
                        {
                            title: '月份',
                            dataIndex: 'issuingMonth',
                            align:'center',
                            width:100,
                            sorter: (a, b) => a.issuingMonth.replace('-','') - b.issuingMonth.replace('-','') ,
                        },
                        {
                            title: '工号',
                            dataIndex: 'teacherId',
                            align:'center',
                            width:110,

                        },
                        
                        {
                            title: '姓名',
                            dataIndex: 'teacherName',
                            align:'left',
                            width:100,
                        },
                        {
                            title: '职称',
                            dataIndex: 'technicalTitleName',
                            align:'center',
                            align:'left',
                            width:100,
                        },
                        {
                            title: '部门',
                            dataIndex: 'orgName',
                            align:'center',
                            align:'left',
                            width:'7%',
                        },
                        {
                            title: '每月实发',
                            dataIndex: 'actualAmount',
                            align:'right',
                            width:100,
                            sorter: (a, b) => a.actualAmount - b.actualAmount,

                        },
                        {
                            title: '专项奖励',
                            dataIndex: 'specialAward',
                            align:'right',
                            width:100,
                            sorter: (a, b) => a.specialAward - b.specialAward,
                        },
                        {
                            title: '奖励/课酬',
                            dataIndex: 'rewardAmount',
                            align:'right',
                            width:100,
                            sorter: (a, b) => a.rewardAmount - b.rewardAmount,
                        },
                        {
                            title: '饭贴',
                            dataIndex: 'riceSubsidy',
                            align:'right',
                            width:100,
                            sorter: (a, b) => a.riceSubsidy - b.riceSubsidy,
                        },
                        {
                            title: '补发',
                            dataIndex: 'backpayAmount',
                            align:'right',
                            width:100,
                            sorter: (a, b) => a.backpayAmount - b.backpayAmount,
                        },
                        {
                            title: '扣发',
                            dataIndex: 'garnishedWages',
                            align:'right',
                            width:100,
                            sorter: (a, b) => a.garnishedWages - b.garnishedWages,
                        },
                        {
                            title: '其他',
                            dataIndex: 'other',
                            align:'right',
                            width:100,
                            sorter: (a, b) => a.other - b.other,
                        },
                        {
                            title: '应发合计',
                            dataIndex: 'totalAmount',
                            align:'right',
                            width:100,
                            sorter: (a, b) => a.totalAmount - b.totalAmount,
                        },
                        {
                            title: '状态',
                            dataIndex: 'approvalStatus',
                            align:'center',
                            width:80,
                            customRender: (text, row, index) => {
                                return text == 'draft' ? '待确定' : '已确认'
                            },
                        },
                        {
                            title: '备注',
                            dataIndex: 'comments',
                            align:'left',
                            width:100,
                            ellipsis:true,
                        },
                    ]
    export default {
        name: 'teacher',
        data () {
            return {
                userId:'',
                xbArr:[],
                zcArr:[],
                data:[],
                loading: false,
                pagination:{
                    current: 1,//当前页数
                    pageSize: 10,
                    pageSizeOptions: ['10', '20','200'],
                    showTotal: (total, range) => {
                    return " 共" + total + "条"
                    },
                    showQuickJumper: true,
                    showSizeChanger: true,
                    total: 0
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                    orgCode:'',
                    technicalTitleCode:'',
                    teacherIdOrName:'',
                    startDate:'',
                    endDate:'',
                    approveStatus:'',
                },
                permissions:[],
                sysRoles:[],
                columns:columns
            }
        },
        mounted () {

            if(this.sysRoles.indexOf("ROLE_ORG_ADMIN") > -1){
                this.columns.forEach((e,index)=>{
                    if(e.dataIndex == 'approvalStatus'){
                        this.columns.splice(index,1)
                    }
                })
            }
            this.selectedRowKeys = []
            this.userId=this.$store.state.user.userId
            this.$store.state.user.sysRoles.forEach(element => {
                this.sysRoles.push(element.code)
            });
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'ZC',status:true}).then(res=>{
                this.zcArr=res.data.dicts;
            })

            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.searchFrom.startDate = this.getYearMonth()
            this.searchFrom.endDate = this.getYearMonth()
            this.fetch()
        },
        watch:{
            '$route':{
                handler(newVal,oldVal){
                    if(newVal.path === '/admin/faculty/payroll'){
                        this.fetch()
                    }
                },
                deep:true,
                immediate:true
            }
        },
        methods:{
            getYearMonth(){
                let month = new Date().getMonth()+1;
                let year = new Date().getFullYear();
                return month < 10 ? (year + '-0' + month) : (year + '-' + month)
            },
            month(val){
                this.searchFrom.endDate = val
            },
            del(){
                var map={};
                this.data.forEach(element=>{
                    map[element.id]=element
                })
                var flag=false; 
                this.selectedRowKeys.forEach(element=>{
                    if(map[element].approvalStatus=='approved'){
                        flag=true
                    }
                })
                if(flag){
                    this.$notification['info']({
                        message: '提示',
                        description:'只能删除未确认的',
                    });
                }else{
                    if(this.selectedRowKeys.length > 0){
                        del(this.selectedRowKeys).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'批量删除成功',
                                });
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                            this.selectedRowKeys=[]
                            this.fetch()
                        })
                    }else{
                        this.$notification['info']({
                            message: '提示',
                            description:'请选择记录',
                        });
                    }
                }
            },
            approved(){
                var map={};
                this.data.forEach(element=>{
                    map[element.id]=element
                })
                var flag=false; 
                this.selectedRowKeys.forEach(element=>{
                    if(map[element].approvalStatus=='approved'){
                        flag=true
                    }
                })
                if(flag){
                    this.$notification['info']({
                        message: '提示',
                        description:'只能确认未确认的',
                    });
                }else{
                    if(this.selectedRowKeys.length > 0){
                        approved(this.selectedRowKeys).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'批量确认成功',
                                });
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                            this.selectedRowKeys=[]
                            this.fetch()
                        })
                    }else{
                        this.$notification['info']({
                            message: '提示',
                            description:'请选择记录',
                        });
                    }
                }
            },
            selectedCheck(){
                selectedCheck()
            },
            exportFile(){
                exportFile(this.searchFrom).then(res=>{
                    if(res){
                        this.$notification['success']({
                            message: '成功',
                            description:'导出工资发放成功',
                        });
                        window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })  
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.courseId=record.courseInfoId
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                pager.pageSize=pagination.pageSize;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                this.data = []
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records
                    this.loading = false;
                })
            },
            searchList(){
                this.selectedRowKeys=[]
                this.pagination.current=1;
                this.fetch()
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            edit(type){
                if(this.selectedRowKeys.length<=1){   
                    var info={};
                    this.data.forEach(element=>{
                        if(element.id == this.selectedRowKeys[0]){
                            info=element
                        }
                    })
                    console.log(JSON.stringify(info))
                    this.$router.push({name:'工资发放',params:{type:type,info:JSON.stringify(info)}}) 
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择一条记录',
                    });
                }
            },
        }
    }
</script>
<style scoped>
    .search-box-1
    {
        margin-bottom: 10px;
    }

    .search-box-1 p
    {
        display: inline-block;
    }
    .search-box-1 .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box-1 .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }

    .search-box .input-box-short{
        margin-right: 1rem;
        width: 7rem;
    }

    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-dropdown-link{
        display: inline-block;
        font-size: 0.9rem;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
    .pagination{
        margin-top: 15px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
</style>
